export default __webpack_public_path__ + "static/media/Camera.8fcc4a6b.svg";